module.exports = __webpack_public_path__ + "img/money.8667ad07.svg";